import React from "react";
import { useNavigate } from "react-router";
import CallIcn from "../../styles/webroot/images/call-icn.png";
import FAQIcon from "../../styles/webroot/images/faq.png";
import { useLanguage } from "@src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";
import { ROLE } from '@src/config/id/constant';
type SupportProps = {
    masterConfig: any
};



const Support = (props: SupportProps) => {
 let user_data = secureStorage.getItem("authAgentUserInfo");
  const roleId = user_data?.user_data?.role_id;
  const navigate = useNavigate();
  const {translations} = useLanguage();
  const handleClick = (type: string) => {
    if (type === "faq") {
      navigate("/faq-list");
    } else {
      navigate("/support-list");
    }
  };

  return (
    <React.Fragment>
       <div className={`${[ROLE.BM, ROLE.VP, ROLE.SH].includes(roleId) ? 'col-md-4 col-xs-12' : 'col-md-6 col-xs-12'} m-lg-t`}>
        <div className="task-summery-outer bg-white quick-support-outer">
          <div className="row">
            <div className="col-md-12 w-100">
              <div className="summery-heading">
                <h2>{translations?.DASHBOARD?.QUICK_LINKS}</h2>
              </div>
              <div className="row">
                <div className="col-md-6 col-xs-6">
                  <div className="quick-support-bg">
                    <img src={CallIcn} alt="Call Icon" />
                    <label>{translations?.DASHBOARD?.SUPPORT}</label>
                    <span>9 AM to 6 PM</span>
                    <a className="action-arrow">
                      <i
                        className="ic-keyboard_arrow_right"
                        onClick={() => handleClick("support")}
                      ></i>
                    </a>
                  </div>
                </div>
                <div className="col-md-6 col-xs-6">
                  <div className="quick-support-bg">
                    <img src={FAQIcon} alt="Mail Icon" />
                    <label>{translations?.DASHBOARD?.FAQ}</label>
                    <span>{translations?.DASHBOARD?.COMMON_QUES}</span>

                    <a className="action-arrow">
                      <i
                        className="ic-keyboard_arrow_right"
                        onClick={() => handleClick("faq")}
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Support;
